import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Button } from '@/components/ui/button';
import { CombinedInputStep } from './steps/CombinedInputStep';
import { CombinedResultsStep } from './steps/CombinedResultsStep';
import { ConfirmationModal } from './ConfirmationModal';
const steps = ['input', 'results'];
const stepInfo = {
  input: {
    title: "Let's Get the Details Locked In",
    description: 'Enter your cargo dimensions, weight, and volume so we can match them to real-world barge specs. You can add multiple cargo items to see the total requirements.'
  },
  results: {
    title: "Here's Your Barge Estimate",
    description: "Based on your cargo details, here's a summary of your requirements and the recommended barge options. Want a fully engineered stowage plan? Just fill out the form below."
  }
};
export function MultiStepForm() {
  const [currentStep, setCurrentStep] = useState('input');
  const [formData, setFormData] = useState({});
  const [isDataComplete, setIsDataComplete] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const handleNext = () => {
    const currentIndex = steps.indexOf(currentStep);
    if (currentIndex < steps.length - 1) {
      setCurrentStep(steps[currentIndex + 1]);
    }
  };
  const handlePrevious = () => {
    const currentIndex = steps.indexOf(currentStep);
    if (currentIndex > 0) {
      setCurrentStep(steps[currentIndex - 1]);
    }
  };
  // Check if there's data to validate going to results
  const validateInputs = () => {
    // Simple validation - check if there's at least one row of data
    return formData.tableData && formData.tableData.length > 0 && formData.tableData.some(row => row.rawWeight > 0 && row.rawLength > 0);
  };
  const handleContinueToResults = () => {
    // Show confirmation modal first
    setShowConfirmationModal(true);
  };
  const handleConfirmAndContinue = updatedFormData => {
    if (validateInputs()) {
      setIsDataComplete(true);
      // If we have updated form data with contact info, use it
      if (updatedFormData) {
        setFormData(updatedFormData);
      }
      handleNext();
    }
  };
  return <div className="w-full min-h-screen bg-[#1a365d] p-8" data-id="element-92">
      {/* Intro Section - Now outside the white box */}
      <div className="max-w-[1440px] mx-auto mb-8 text-center text-white" data-id="element-93">
        <h2 className="text-3xl font-bold mb-4" data-id="element-94">
          How Many Barges Do You Actually Need? Let's Run the Numbers Together.
        </h2>
        <p className="text-lg max-w-3xl mx-auto opacity-90" data-id="element-95">
          Overloading? Underutilizing? Don't guess—calculate. This free stowage
          calculator helps you estimate exactly how many barges you'll need
          based on your cargo parameters. Upload your specs, and we'll break it
          down with precision—just like we do for the biggest engineering and
          marine projects on the Gulf.
        </p>
      </div>
      <div className="max-w-[1440px] mx-auto bg-white rounded-lg shadow-xl p-6" data-id="element-96">
        <Tabs value={currentStep} className="w-full" data-id="element-97">
          <TabsList className="grid w-full grid-cols-2 mb-8" data-id="element-98">
            <TabsTrigger value="input" className="data-[state=active]:bg-[#1a365d] data-[state=active]:text-white" data-id="element-99">
              1: Input Your Cargo Data
            </TabsTrigger>
            <TabsTrigger value="results" className="data-[state=active]:bg-[#1a365d] data-[state=active]:text-white" disabled={!isDataComplete} data-id="element-100">
              2: View Results
            </TabsTrigger>
          </TabsList>
          {/* Step Content Header */}
          <div className="mb-8" data-id="element-101">
            <h3 className="text-2xl font-bold mb-2" data-id="element-102">
              {stepInfo[currentStep].title}
            </h3>
            <p className="text-gray-600" data-id="element-103">{stepInfo[currentStep].description}</p>
          </div>
          <TabsContent value="input" data-id="element-104">
            <CombinedInputStep formData={formData} setFormData={setFormData} data-id="element-105" />
            <div className="flex justify-end mt-8" data-id="element-106">
              <Button onClick={handleContinueToResults} className="bg-[#1a365d]" data-id="element-107">
                Calculate Results
              </Button>
            </div>
          </TabsContent>
          <TabsContent value="results" data-id="element-108">
            <CombinedResultsStep formData={formData} data-id="element-109" />
            <div className="flex justify-between mt-8" data-id="element-110">
              <Button variant="outline" onClick={handlePrevious} data-id="element-111">
                Back to Input
              </Button>
            </div>
          </TabsContent>
        </Tabs>
        {/* Company Logo Section */}
        <div className="mt-12 pt-8 border-t text-center" data-id="element-112">
          <img src="https://placehold.co/200x60?text=Company+Logo" alt="Company Logo" className="mx-auto h-12 object-contain" data-id="element-113" />
        </div>
      </div>
      {/* Confirmation Modal */}
      <ConfirmationModal open={showConfirmationModal} onOpenChange={setShowConfirmationModal} formData={formData} onConfirm={handleConfirmAndContinue} data-id="element-114" />
    </div>;
}